import { render, staticRenderFns } from "./perfect.vue?vue&type=template&id=ba07998a&scoped=true&"
import script from "./perfect.vue?vue&type=script&lang=js&"
export * from "./perfect.vue?vue&type=script&lang=js&"
import style0 from "./perfect.vue?vue&type=style&index=0&id=ba07998a&lang=scss&scoped=true&"
import style1 from "./perfect.vue?vue&type=style&index=1&id=ba07998a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07998a",
  null
  
)

export default component.exports